import { push } from 'connected-react-router';
import produce from 'immer';
import toast from 'react-hot-toast';
import { takeEvery, put, call, select } from 'redux-saga/effects';
import * as showcaseApi from '../../api/showcaseApi';
import * as actions from '../actions';
import * as selectors from '../selectors';
import * as moment from 'moment';
import { getFirmsOrWait, getUserOrWait, waitFor } from './sagaUtils';

export function* getAdSlots() {
  try {
    let user = yield getUserOrWait();
    yield call(waitFor, state => state.firm.firmsForLookup);
    const firms = yield select(selectors.firms.firmsForUserCompany);

    const isGowUser = yield select(selectors.users.isGowUser);
    const query = yield select(selectors.showcase.slotQuery);
    const activePage = yield select(selectors.showcase.slotPage);

    const filter = { isDeleted: { is: false } };
    if (query.site) filter.sites = { siteId: { eq: query.site } };
    if (query.firmId) filter.firms = { firmId: { eq: query.firmId } };

    if (!isGowUser) {
      filter.firms = { firmId: { in: firms } };
    }

    if (query.status) {
      switch (query.status) {
        case 'Active':
          filter.startDate = { lte: moment().format('YYYY-MM-DD') };
          filter.endDate = { gte: moment().format('YYYY-MM-DD') };
          break;
        case 'Inactive':
          filter.endDate = { lt: moment().format('YYYY-MM-DD') };
          break;
        default:
          break;
      }
    }

    yield put(actions.user.setLoading(true));
    const { slots, count } = yield call(showcaseApi.getAdSlots, {
      filter,
      offset: (activePage - 1) * 20,
      pageSize: 20,
    });

    yield put(actions.adSlot.getAdSlotsSuccess(slots, count));
  } catch (e) {
    console.log(e);
    yield put(actions.adSlot.getAdSlotsFail(e.message));
    toast.error('An error occurred loading ad slots.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* getAdSlotById({ payload: { id } }) {
  try {
    if (!id) {
      return;
    }
    yield put(actions.user.setLoading(true));
    const slot = yield call(showcaseApi.getAdSlotById, id);
    yield put(actions.adSlot.getAdSlotByIdSuccess(slot));
    // yield put(actions.adSlot.getItemsForFirms(slot.firmIds));
    yield put(actions.showcase.preloadShowcaseData());
  } catch (e) {
    yield put(actions.adSlot.getAdSlotByIdFail(e.message));
    toast.error('An error occurred getting ad slot.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* addAdSlot({ payload: { slot, firmId } }) {
  try {
    const _slot = yield call(showcaseApi.addAdSlot, slot);
    yield put(actions.adSlot.addAdSlotSuccess(_slot));
    yield put(actions.firm.getFirmById(firmId));
    toast.success('Ad slot created.');
    yield put(actions.adSlot.getAdSlots());
    yield put(push('/ad-slot'));
  } catch (e) {
    yield put(actions.adSlot.addAdSlotFail(e.message));
    toast.error('An error occurred creating ad slot.');
  }
}
export function* updateAdSlot({ payload: { slot, firmId } }) {
  try {
    yield call(showcaseApi.updateAdSlot, slot);
    yield put(actions.adSlot.updateAdSlotSuccess());
    yield put(actions.adSlot.getAdSlotById(slot.id));
    yield put(actions.firm.getFirmById(firmId));
    yield put(actions.adSlot.getAdSlots());
    toast.success('Ad slot updated.');
  } catch (e) {
    yield put(actions.adSlot.updateAdSlotFail(e.message));
    toast.error('An error occurred updating ad slot.');
  }
}
export function* getItemsForFirms({ payload: { firmIds } }) {
  try {
    // const firms = yield select(selectors.firm.firms);
    const items = yield call(showcaseApi.getItemsForFirms, firmIds);
    console.log('get items for firms', { firmIds, items });
    yield put(actions.adSlot.getItemsForFirmsSuccess(items));
  } catch (e) {
    yield put(actions.adSlot.getItemsForFirmsFail(e.message));
    toast.error('An error occurred retrieving listing items.');
  }
}
export function* updateCurrentAdSlotItems({ payload: { itemIds } }) {
  try {
    const base = yield select(selectors.getCurrentAdSlot);
    const slot = produce(base, draft => {
      draft.itemIds = itemIds;
    });
    yield put(actions.adSlot.updateCurrentAdSlotItemsSuccess(slot));
  } catch (e) {
    yield put(actions.adSlot.updateCurrentAdSlotItemsFail(e.message));
    toast.error('An error occurred retrieving listing items.');
  }
}

export function* searchAdSlots({ payload: { query } }) {
  try {
    yield put(actions.user.setLoading(true));
    const slots = yield call(showcaseApi.searchAdSlots, query);
    yield put(actions.adSlot.searchAdSlotsSuccess(slots));
  } catch (e) {
    yield put(actions.adSlot.searchAdSlotsFail(e.message));
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* loadAdSlotSearchPage({
  payload: {
    location: { pathname },
  },
}) {
  try {
    if (pathname !== '/ad-slot') return;
    console.log('load ad slot search page');
    yield put(actions.adSlot.getAdSlots());
    yield put(actions.firm.getFirmsForLookup());
  } catch (e) {
    console.log(e);
  }
}

export function* adSlotSagas() {
  yield takeEvery(actions.adSlot.getAdSlots, getAdSlots);
  yield takeEvery(actions.adSlot.getAdSlotById, getAdSlotById);
  yield takeEvery(actions.adSlot.addAdSlot, addAdSlot);
  yield takeEvery(actions.adSlot.updateAdSlot, updateAdSlot);
  yield takeEvery(actions.adSlot.searchAdSlots, searchAdSlots);
  yield takeEvery(actions.adSlot.getItemsForFirms, getItemsForFirms);
  yield takeEvery(actions.adSlot.updateCurrentAdSlotItems, updateCurrentAdSlotItems);
  // yield takeEvery('@@router/LOCATION_CHANGE', loadAdSlotSearchPage);
  // yield takeEvery('@@router/LOCATION_CHANGE', console.log);
}
